import React from 'react'
import style from './InventoryLocationsList.module.css'
import { Inventory } from '../../../../../assets/icons'
import { Translate } from '../../../../../language'
import TitleSVG from '../../../../../utils/components/TitleSVG/TitleSVG'
import Input from '../../../../../utils/components/Input/Input';
import Item from './Item'
import ListItems from './ListItems'

const InventoryLocationsList = ({ inventoryItems, skip, setSkip, limit, setSearch, onClickRow, inventoryType }) => {

    const idTimeOuts = [];

     const searchUser = (value) => {
        setSearch(value);
        clearTimeout(idTimeOuts[0]);
        idTimeOuts.length = 0;
    }

    const scrollPagination = (e) => {
        if (e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
            setSkip(skip + limit);
        }
    }
    
    const onSearchValueChange = (e) => {
        let value = e.target.value;

        if (idTimeOuts.length ===0) {
            idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
        }

        else {
            clearTimeout(idTimeOuts[0]);
            idTimeOuts.shift();
            idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
        }
    }

    return (
        <div>
            <div className={style.record_container}>
                <TitleSVG Icon={Inventory}
                    titleHighlight={Translate('inventoryLocationsListTitleHighlight', 'es')}
                    title={Translate('inventoryLocationsListTitle', 'es')} />

                <div className={style.form_content}>
                    <label >{Translate('search', 'es')}</label>

                    <Input
                        type="email"
                        placeholder={Translate('nameOrCode', 'es')}
                        name="email"
                        classNameInput={style.form_input}
                        onChange={onSearchValueChange}
                    />
                </div>

                <div className={style.record_grid_container}>
                    <div className={style.record_grid} onScroll={scrollPagination}>
                        <div className={style.record_grid_title}>código</div>
                        <div className={style.record_grid_title}>nombre</div>
                        <div className={style.record_grid_title}>ubicación</div>

                        <ListItems>
                            {inventoryItems.map(record => (
                                <Item
                                    onClickRow={onClickRow}
                                    key={record.id}
                                    id={record.id}
                                    code={record.code}
                                    name={record.name}
                                    location={record.location}
                                    inventoryType={inventoryType}
                                />
                            ))}
                        </ListItems>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default InventoryLocationsList